import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../styles/NeedGuidance.module.scss";
import { useRouter } from "next/router";
import { getOnboardingOrFormCtaProps } from "../utils/applyCtaButtonProps";
import { persistSourceContext } from "../utils/b2c/sourceTracking";
import { PRIMARY_SOURCE_B2C_WIDGET } from "../utils/b2c/constants";

interface buttonsProps {
  title?: string;
  link?: string;
  formId: string;
  toOnboardingEnabled?: boolean;
  lookingForCoaching?: boolean;
  nearestOffice?: boolean;
}
interface Props {
  classname?: string;
  button2Data?: buttonsProps;
}

const NeedGuidance: React.FC<Props> = ({ classname, button2Data }) => {
  const router = useRouter();

  const applyCtaButtonProps1 = getOnboardingOrFormCtaProps(router, {
    btnLink: button2Data?.link,
    formId: button2Data?.formId,
    toOnboardingEnabled: button2Data?.toOnboardingEnabled,
    sourceUrl: typeof window !== "undefined" ? window.location.pathname : "",
  });

  const ctaBtnClickHandler = (applyCtaButtonProps: any) => (e: React.MouseEvent<HTMLDivElement>) => {
    if (applyCtaButtonProps.mode === "onboarding") {
      persistSourceContext({
        sourceUrl: window.location.href,
        primarySource: PRIMARY_SOURCE_B2C_WIDGET,
        fifthStepVisible: button2Data?.nearestOffice ?? true,
        coachingVisible: button2Data?.lookingForCoaching ?? true,
      });
    }
    applyCtaButtonProps.onClick?.(e);
  };

  return (
    <>
      <div id="need-guidance" className={styles.studentFooter}>
        <Container>
          <Row>
            <Col>
              <div className={styles.session}>
                <div>
                  <p style={{ fontSize: "26px" }}>Need guidance? Let us help you.</p>
                </div>
                <div className={styles.anchor}>
                  <a href="/contact-us" className={styles.btTranparent}>
                    Contact Us
                  </a>
                  <div
                    className={`${styles.enquireBtn} ${classname || ""} ${applyCtaButtonProps1.formClassName}`}
                    onClick={button2Data ? ctaBtnClickHandler(applyCtaButtonProps1) : undefined}
                  >
                    {button2Data?.title ?? "Enquire Now"}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default NeedGuidance;
